var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.VieraHtml5 = youbora.StandardAdapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.currentTime
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.currentSrc
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Panasonic Viera"
  },

  initializeAdapter: function () {
    this.monitorPlayhead(true, false)
  },

  getListenersList: function () {
    return [{
      events: {
        'play': this.playListener,
        'timeupdate': this.timeupdateListener,
        'pause': this.pauseListener,
        'playing': this.playingListener,
        'error': this.errorListener,
        'seeking': this.seekingListener,
        'seeked': this.seekedListener,
        'ended': this.endedListener,
        'canplay': null,
        'buffering': null,
        'waiting': null,
        'abort': null,
        'seek': null,
        'stalled': null,
        'dispose': null,
        'loadeddata': null,
        'loadstart': null
      }
    }]
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'timeupdate' event. */
  timeupdateListener: function (e) {
    if (this.getPlayhead() > 0.1) {
      this.fireStart()
      this.fireJoin()
      this.fireSeekEnd()
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireResume()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError("PLAY_FAILURE")
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'seeked' event. */
  seekedListener: function (e) {
    this.fireSeekEnd()
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  }
})

module.exports = youbora.adapters.VieraHtml5
